import {PredicateOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ClientRequiredTaggingParameter} from '../../../../../../models/api/requiredTaggingModel';

/*
 * Type enum.
 */

export enum RequiredTaggingParamsEditorActionTypesEnum {
  ADD_PARAMETER = '@@required_tagging_params_editor/ADD_PARAMETER',
  UPDATE_PARAMETER = '@@required_tagging_params_editor/UPDATE_PARAMETER',
  DELETE_PARAMETER = '@@required_tagging_params_editor/DELETE_PARAMETER',
}

/*
 * Types.
 */

interface AddParameter {
  type: RequiredTaggingParamsEditorActionTypesEnum.ADD_PARAMETER;
  parameter: ClientRequiredTaggingParameter;
}

interface UpdateParameter {
  type: RequiredTaggingParamsEditorActionTypesEnum.UPDATE_PARAMETER;
  predicate: PredicateOf<ClientRequiredTaggingParameter>;
  update(requiredTaggingParameter: ClientRequiredTaggingParameter): ClientRequiredTaggingParameter;
}

interface DeleteParameter {
  type: RequiredTaggingParamsEditorActionTypesEnum.DELETE_PARAMETER;
  predicate: PredicateOf<ClientRequiredTaggingParameter>;
}

export type RequiredTaggingParamsEditorAction = AddParameter | UpdateParameter | DeleteParameter;
